<script setup>
import ModalWrapper from '@/modals/ModalWrapper';

defineProps({
    title: {
        type: String,
        default: 'Confirmation'
    },

    prompt: {
        type: String,
        default: 'Confirmation'
    }
});

const emit = defineEmits(['close-modal', 'cancel-modal']);

const confirmModal = () => {
    emit('close-modal', true);
};
</script>

<template>
<ModalWrapper
    body-class="modal-default-content"
    :fixed-height="false"
    @cancel-modal="emit('cancel-modal')">
    <template #header>{{ title }}</template>
    <template #subheader>{{ prompt }}</template>

    <template #footer>
        <StyledButton @click="confirmModal">{{ $t('label.confirmation') }}</StyledButton>
    </template>
</ModalWrapper>
</template>

